import CommonSharedFileDetail from '../../../common/pages/secure/SharedFileDetail'
import Config from '../../../Config'

class SharedFileDetail extends CommonSharedFileDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.apiUrlToDownlaod = Config.adminApiUrl.sharedFileDownlaod
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
    this.isShowingEditButton = true
    this.isShowingDeleteButton = true
  }
}

export default SharedFileDetail



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SharedFileDetail.js